import React from 'react';
import { useShowController, useTranslate, SimpleShowLayout, TextField, DateField } from 'react-admin';
import { makeStyles, Typography, Card, CardMedia, CardContent, CardActions, Button, Grid as MuiGrid } from '@material-ui/core';
import { LinkField } from '../../components/fields';

export const useStyles = makeStyles({
	container: {
		marginTop: 24,
	},
	preview: {
		marginBottom: 24,
	},
});

const IdDocumentPreview = ({ idDocument, className }) => {
	const translate = useTranslate();
	if (!idDocument) {
		return null;
	}
	const isImage = idDocument.fileContentType && idDocument.fileContentType.indexOf('/image') !== -1;
	const startDownload = () => {
		window.location.href = idDocument.links.download;
	};
	return (
		<Card className={className}>
			{isImage ? (
				<CardMedia
					image={idDocument.links.content}
				/>
			) : (
				<CardContent>
					<Typography variant="body2" color="textSecondary" component="p">
						{translate('resources.idDocuments.labels.noPreviewPossible')}
					</Typography>
				</CardContent>
			)}
			<CardActions>
				<Button size="small" color="primary" onClick={startDownload}>
					{translate('resources.idDocuments.labels.downloadButton')}
				</Button>
			</CardActions>
		</Card>
	);
};

const IdDocumentShow = props => {
	const classes = useStyles();
	const {
		basePath,
		record,
		resource,
		version,
	} = useShowController(props);
	const showProps = {
		basePath,
		record,
		resource,
		version,
	};
	return (
		<MuiGrid className={classes.container} container>
			<MuiGrid item xs={12} md={6}>
				<IdDocumentPreview className={classes.preview} idDocument={record} />
				<Card>
					<SimpleShowLayout {...showProps}>
						<TextField source="id" />
						<DateField source="creationDateTime" showTime />
						<LinkField source="owner" />
						<TextField source="fileContentType" />
						<TextField source="fileSizeBytes" />
						<TextField source="status" />
						<DateField source="statusDateTime" showTime />
						<TextField source="statusText" />
					</SimpleShowLayout>
				</Card>
			</MuiGrid>
		</MuiGrid>
	);
};

export default IdDocumentShow;
